<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon
          v-if="epfDetail.epf_member_number"
          color="primary"
        >
          mdi-pencil
        </v-icon>

        <v-icon
          v-else
          color="hrissecondary"
        >
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Employee EPF Detail"
      :text="epfDetail.epf_member_number ? 'Update employee EPF detail':'Create employee EPF detail'"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="epfMemberNumber"
                v-validate="'required'"    
                :error-messages="errors.collect('epfMemberNumber')"
                data-vv-name="epfMemberNumber"
                data-vv-as="EPF member number"
                label="EPF Member Number"
              />
            </v-col>
          </v-row>
        </v-container> 
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>  
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      epfDetail: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        loading: false,
        epfMemberNumber: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.epfMemberNumber = this.epfDetail.epf_member_number

        this.loading = false
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.employeePayrollEpf().update(this.employeeUid, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          epf_member_number: this.epfMemberNumber,
        }
      },
    },
  }
</script>
